import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';

type DetailHistoryListType = {
  logHistory: any;
};
const DetailHistoryList: React.FC<DetailHistoryListType> = (props) => {
  const getKeyName = (keyName: string) => {
    let result = '';
    switch (keyName) {
      case 'phone1':
        result = '電話番号';
        break;
      case 'phone2':
        result = '電話番号2';
        break;
      case 'vip':
        result = 'VIPフラグ';
        break;
      case 'prefecture':
        result = '都道府県';
        break;
      case 'fullname':
        result = '患者名';
        break;
      case 'salon_no':
        result = 'サロン番号';
        break;
      case 'kana':
        result = '名前';
        break;
      case 'gender':
        result = '性別';
        break;
      case 'dob':
        result = '生年月日';
        break;
      case 'age':
        result = '年齢';
        break;
      case 'email':
        result = 'メールアドレス';
        break;
      case 'postcode':
        result = '郵便番号';
        break;
      case 'address':
        result = '住所';
        break;
      case 'note':
        result = '備考';
        break;
      default:
        result = keyName;
        break;
    }
    return result;
  };

  const getChanges = (changes: any) => {
    let result = [];

    for (const [key, value] of Object.entries(changes)) {
      let values: string[] = value as string[];

      let item = `${getKeyName(key)} : ${values[0]} -> ${values[1]}`;
      result.push(item);
    }
    result = result.map((res: string, idx: number) => {
      return (
        <Box key={idx} mb='8px'>
          {res}
        </Box>
      );
    });
    return result;
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        width: '100%',
        height: '100%',
      }}
    >
      <Table
        sx={{
          minWidth: 700,
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            p: '6px 16px',
            fontSize: '14px',
          },
          '& .MuiTableCell-root.MuiTableCell-body': {
            color: 'primary.dark',
            fontSize: '14px',
            py: '6px',
          },
        }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            <TableCell width={'150px'}>日時</TableCell>
            <TableCell width={'150px'}>更新者</TableCell>
            <TableCell width={'150px'}>区分</TableCell>
            <TableCell>変更</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.logHistory &&
            props.logHistory.map((log: any, index: number) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
                    py: '16px',
                    borderBottom: '1px solid #F3F3F3',
                  },
                }}
              >
                <TableCell>{log.updated_at}</TableCell>
                <TableCell>{log.updated_by}</TableCell>
                <TableCell>{log.type === '1' ? 'ユーザー' : ''}</TableCell>
                <TableCell>{getChanges(log.changes)}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailHistoryList;
